module.exports = __webpack_public_path__ + "img/pr-7.1b2fb009.png";